(function () {
  if (typeof window.debounce !== 'function') {
    window.debounce = function debounce(fn, wait) {
      var timeout;

      return function debounced() {
        var args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          fn.apply(this, args);
        }, wait);
      };
    };
  }

  if (typeof window.fetchConfig !== 'function') {
    window.fetchConfig = function fetchConfig(type) {
      return {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/' + (type || 'json'),
        },
      };
    };
  }

  if (typeof window.trapFocus !== 'function') {
    window.trapFocus = function trapFocus(_container, elementToFocus) {
      if (elementToFocus && typeof elementToFocus.focus === 'function') {
        elementToFocus.focus();
      }
    };
  }

  if (typeof window.CartPerformance === 'undefined') {
    window.CartPerformance = {
      createStartingMarker: function () {
        return null;
      },
      measure: function (_name, callback) {
        return callback();
      },
      measureFromMarker: function () {},
      measureFromEvent: function () {},
    };
  }

  if (!customElements.get('cart-drawer-items')) {
    customElements.define(
      'cart-drawer-items',
      class CartDrawerItems extends HTMLElement {
        constructor() {
          super();
          this.lineItemStatusElement = document.getElementById('CartDrawer-LineItemStatus');

          this.addEventListener(
            'change',
            window.debounce((event) => {
              if (!event.target.matches('.quantity__input')) return;
              this.updateQuantity(event.target.dataset.index, parseInt(event.target.value, 10), event);
            }, window.ON_CHANGE_DEBOUNCE_TIMER || 300)
          );
        }

        getSectionsToRender() {
          return [
            {
              id: 'CartDrawer',
              section: 'cart-drawer',
              selector: '#CartDrawer',
            },
            {
              id: 'cart-icon-bubble',
              section: 'cart-icon-bubble',
              selector: '.shopify-section',
            },
          ];
        }

        updateQuantity(line, quantity, event) {
          this.enableLoading(line);

          fetch(window.routes.cart_change_url, {
            ...window.fetchConfig(),
            body: JSON.stringify({
              line: line,
              quantity: quantity,
              sections: this.getSectionsToRender().map((section) => section.section),
              sections_url: window.location.pathname,
            }),
          })
            .then((response) => response.json())
            .then((state) => {
              if (state.errors) {
                this.updateLiveRegions(line, state.errors);
                return;
              }

              this.getSectionsToRender().forEach((section) => {
                var target = document.getElementById(section.id);
                var sectionHtml = state.sections && state.sections[section.section];
                if (!target || !sectionHtml) return;

                var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
                var source = parsed.querySelector(section.selector);
                if (source) target.innerHTML = source.innerHTML;
              });

              var cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer) cartDrawer.classList.toggle('is-empty', state.item_count === 0);

              if (window.publish && window.PUB_SUB_EVENTS) {
                window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                  source: 'cart-items',
                  cartData: state,
                  variantId: event && event.target ? event.target.dataset.quantityVariantId : undefined,
                });
              }
            })
            .catch(() => {
              var errors = document.getElementById('CartDrawer-CartErrors');
              if (errors && window.cartStrings) errors.textContent = window.cartStrings.error;
            })
            .finally(() => this.disableLoading(line));
        }

        updateLiveRegions(line, message) {
          var lineItemError = document.getElementById('CartDrawer-LineItemError-' + line);
          if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;
        }

        enableLoading(line) {
          var cartItems = document.getElementById('CartDrawer-CartItems');
          if (cartItems) cartItems.classList.add('cart__items--disabled');
          this.querySelectorAll('#CartDrawer-Item-' + line + ' .loading__spinner').forEach((overlay) =>
            overlay.classList.remove('hidden')
          );
          if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
        }

        disableLoading(line) {
          var cartItems = document.getElementById('CartDrawer-CartItems');
          if (cartItems) cartItems.classList.remove('cart__items--disabled');
          this.querySelectorAll('#CartDrawer-Item-' + line + ' .loading__spinner').forEach((overlay) =>
            overlay.classList.add('hidden')
          );
        }
      }
    );
  }
})();
